// removed by extract-text-webpack-plugin
module.exports = {"base":"Pagination_base--16i5I","content":"Pagination_content--1Yu3f","list":"Pagination_list--3ygQE","children":"Pagination_children--v2Hu4"};


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/Pagination.scss
// module id = 2366
// module chunks = 11